import cancerProstateImg from '@/assets/images/health-men/cancer-prostate.svg?url';
import cancerColorectalImg from '@/assets/images/health-men/cancer-colorectal.svg?url';
import depistageImg from '@/assets/images/health-men/depistage.png?url';
import santeHommeImg from '@/assets/images/health-men/sante-homme.svg?url';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — filename has a space
import autopalpationImg from '@/assets/images/health-men/autopalpation testicules.svg?url';

export const MODAL_CONTENT_HEALTH_MEN = {
  HYGIENE: `
- Mangez au moins 5 portions de <b>fruits et légumes</b> frais par jour
- Consommez au moins 1 féculent complet par jour
- Mangez des légumes secs au moins 2 fois par semaine
- Utilisez des huiles végétales et des cuissons vapeurs
- Privilégiez la <b>volaille</b> à la viande rouge, et limiter la consommation de viande rouge à 500g par semaine
- Mangez à heure régulière
- Buvez au moins 1,5l d'eau par jour
- <b>Tabac</b>: le tabagisme arrive en tête de toutes les causes de cancers, loin devant les autres facteurs de risques, qu'il soit passif ou actif.
- <b>Alcool</b> : l'alcool représente la deuxième cause évitable de mortalité par cancer. Dès une consommation moyenne d'un verre par jour, l'augmentation du risque de développer un cancer est significative.
  - <u>Recommandations de santé publique </u>: modérez votre consommation (pas plus de 2 verres standards par jour, et avoir des jours dans la semaine sans consommation).
`,

  SPORT: `
- L'activité physique diminue le risque de survenue de tous les cancers
- Pratiquer <b>au moins 30 minutes d'activité physique modérée à élevée</b> par jour au moins 5 jours par semaine (évitez de rester 2 jours consécutifs sans pratiquer)
- Positions assise ou allongée : marchez quelques minutes toutes les <b>90 à 120 minutes</b> pour limiter la sédentarité
- Utilisez un objet connecté (podomètre, application mobile) pour suivre votre nombre de pas quotidiens et l'augmenter !
- Autres conseils pour augmenter votre activité physique au quotidien :
  - Vous donner l'objectif d'effectuer l'équivalent de 10 000 pas quotidiens
  - Privilégier les escaliers à l'ascenseur ou l'escalator
  - Favoriser les trajets à pieds
`,

  SYMPTOMS: `
<b>Cancer des testicules</b>

- <b>Masse</b> dure et indolore dans la glande ou qui englobe la glande
- Une augmentation du volume de la bourse
- Troubles de la fertilité
- Troubles digestifs (plus rare)

<b>Cancer de la prostate</b>

Il est possible de n'avoir aucun symptôme aux premiers stades de la maladie !

- Besoin fréquent et/ou urgent d'uriner
- Difficultés à <b>uriner</b> (miction difficile à commencer ou arrêter, jet d'urine faible ou qui s'interrompt)
- Sensation de ne pas avoir totalement vidé sa vessie
- Brûlure ou douleur en urinant
- Présence de sang dans l'urine ou le sperme
- Troubles sexuels (dysfonctionnement de l'érection, éjaculations douloureuses)
- Douleurs au niveau des os (dos, bassin, jambes)

<img src="${cancerProstateImg}" />

<b>Cancer colorectal</b>

- <b>Présence de sang dans les selles</b>
- Douleurs abdominales
- Troubles élimination fécale (constipation soudaine, diarrhée prolongée, envie constante d'aller à la selle)

<b>Symptômes communs fréquents</b> : altération de l'état général (perte de poids, fatigue généralisée)

<img src="${cancerColorectalImg}" />
`,
  MODALITY: `
<b>Cancer des testicules</b>

- Palpation (cf. initiation à <span class="text-blue">l'Autopalpation</span>)
- Echographie scrotale bilatérale (des 2 testicules)
- Dosage de marqueurs tumoraux (corrélé à l'évolution de la tumeur)

<b>Cancer de la prostate</b>

1/ <b>Le toucher rectal</b> : examen de la prostate indolore (mais inconfortable) mené par un médecin, qui permet de vérifier le volume, la consistance et la texture de la prostate.

2/ Le <b>dosage</b> du PSA (antigène prostatique spécifique) :

- Examen via une prise de sang qui permet de vérifier le taux de PSA dans le sang (normalement faible)
- Un taux élevé de PSA peut être révélateur d'un cancer de la prostate ou d'une autre maladie (hypertrophie de la prostate, prostatite ou infection urinaire)

<b>Cancer colorectal</b>

<b>Programme de dépistage national (<span class="text-blue">Mars Bleu</span>) :</b>

- Dépistage tous les 2 ans, ciblant les femmes et hommes entre 50 et 74 ans qui ne présentent PAS de symptômes, d'antécédents personnels ou familiaux ou de facteurs de risques particuliers
- Etapes du dépistage :
  - <b>Test d'immunologie</b> de recherche de sang dans les selles : prélèvement à domicile puis analyse en laboratoire
  - <b>Coloscopie</b> en cas de sang détecté dans les selles (dans plus de 50% des cas, aucune anomalie)
- Réception d'un courrier de l'Assurance Maladie pour obtenir un kit de dépistage :

<img src="${depistageImg}" />

<b>Evénement commun :</b> Mouvement <b>Movember</b> au mois de Novembre (prévenir et soutenir la recherche sur les maladies masculines)
`,

  TREATMENT: `
Suite aux examens de dépistage, des <b>examens complémentaires</b> sont menés afin de vérifier le stade du cancer et de déterminer les meilleurs traitements (échographie, coloscopie, biopsie, analyse anatomopathologique, bilan sanguin d'extension).

Une concertation pluridisciplinaire peut être menée afin de proposer les meilleurs traitements parmi :

- <b>Chirurgie</b> (ablation testicule, prostatectomie, colectomie)
- <b>Radiothérapie</b>
- <b>Chimiothérapie</b>

<img src="${santeHommeImg}" />
`,

  SELF_PALPATION: `
<b>Initiation du patient à l'autopalpation</b>

<b>A quel âge ?</b>
L'autopalpation peut se pratiquer seul, chez soi, dès l'âge de 14 ans.

<b>Pourquoi ?</b>
L'objectif est de repérer un volume ou une masse potentiellement cancéreuse.

<b>Comment ?</b>

- Après la douche, devant un miroir, observer des changements inhabituels
- Faire rouler la glande entre le pouce et les quatre doigts sous le testicule

<b>Et ensuite ?</b>

- Il est possible qu'un testicule soit plus gros que l'autre
- Il est normal de sentir une formation allongée (épididyme)

<b>IMPORTANT :</b> la présence d'une nouvelle masse doit conduire à consulter un médecin.

<img src="${autopalpationImg}" />
`,
};
